import React from 'react'

import { Button } from 'shared/components'

import { scrollIntoElement } from 'shared/utils'
import { CooperationId } from '../Cooperation'

import classes from './Partners.module.scss'

export const Partners = (): JSX.Element => {
  return (
    <div
      className={`${classes.wrapper} reveal-from-bottom-medium`}
      data-reveal-delay={30}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h2 className={`${classes.title} mb-2 weight-bold uppercase`}>
              <span className={classes.title_desktop}>
                ПАРТНЕРСТВО В ПРОИЗВОДСТВЕ
              </span>
              <span className={classes.title_mobile}>
                Партнерство{'\n'}в производстве
              </span>
            </h2>
          </div>
          <div className="col-xs-12 col-sm-8 col-md-8">
            <p className={`${classes.text} mb-1`}>
              KION создает оригинальный контент в партнёрстве с большим пулом
              студий, <br /> режиссеров и продюсеров
            </p>
          </div>
          <div className="col-xs-12">
            <Button
              onClick={() => {
                scrollIntoElement(CooperationId, undefined, undefined, true)
              }}
            >
              Узнать больше
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
